export const POLL_INTERVAL = 10000
export const TRANSACTION_RELOAD_DELAY = 1000
export const INITIAL_POLL_INTERVAL = 2000
export const OBSERVABLE_THROTTLE_INTERVAL = 1000
export const SECONDS_PER_YEAR = 31536000
export const SEARCH_DEBOUNCE_DELAY = 500
